import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import dayjs from 'dayjs'
import { z } from 'zod'

export const Qc1010SearchParamsSchema = z
  .object({
    refNo: z.string().optional(),
    itemId: z.string().optional(),
    lotNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
    partyId: z.string().optional(),
    purchaseOrderNumber: z.string().optional(),
    pendingOnly: z.boolean().optional().default(true),
  })
  .merge(BasePaginateParamsSchema)

export type Qc1010SearchParams = z.infer<typeof Qc1010SearchParamsSchema>

const holdInfoSchema = z
  .object({
    id: z.string(),
    date: z.coerce.date().nullable(),
    holdResultDate: z.coerce.date().nullable(),
    number: z.string(),
    qty: z.number(),
    taskId: z.number(),
    isSortingReworkApproved: z.boolean().nullable(),
    holdResultQtySortingRework: z.number().nullable(),
    documentType: z.enum(['MRR', 'NCR']).nullable().optional(),
  })
  .transform((v) => ({
    ...v,
    isSortingReworkRequired:
      v.holdResultDate &&
      v.holdResultQtySortingRework != null &&
      v.holdResultQtySortingRework > 0,
  }))
  .transform((v) => ({
    ...v,
    isDone: v.isSortingReworkRequired
      ? v.isSortingReworkApproved != null
      : v.holdResultDate != null,
  }))

export const Qc1010SearchResultModelSchema = z.object({
  id: z.number(),
  refNo: z.string().default(''),
  refDate: z.coerce.date(),
  sourceDocumentNumber: z.string().optional(),
  partyId: z.number(),
  purchaseOrderNumber: z.string().nullable().optional(),
  item: z.object({
    itemId: z.number(),
    lotNo: z.string(),
    lotDate: z.string().transform((v) => dayjs(v).format('YYYY-MM-DD')),
    mold: z.string(),
    unit: z.string(),
    isClaimItem: z.boolean(),
  }),
  qtyToInspect: z.number(),
  qtyRemaining: z.number(),
  qtyPassed: z.number(),
  qtyHold: z.number(),
  qtyRejected: z.number(),
  qtySortingRework: z.number(),
  qtyRemainingQtyForNewPassHold: z.number(),
  createdAt: z.coerce.date(),
  holdInfos: z.array(holdInfoSchema),
  status: z.number().optional(),
})

export type Qc1010SearchResultModel = z.infer<
  typeof Qc1010SearchResultModelSchema
>

export const Qc1010SearchResultSchema = z
  .object({
    items: z.array(Qc1010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Qc1010SearchResult = z.infer<typeof Qc1010SearchResultSchema>
